import React, { useContext } from 'react';
import DocumentListContainer from "./DocumentList/DocumentListContainer";
import { I18nContext } from 'utils/I18n/context';

const InformationPage = () => {
    const { t } = useContext(I18nContext);
    const staticNames = t?.InformationPage || { title: 'Useful Information' };

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>
            <section className="wrapper-content">
                <DocumentListContainer/>
            </section>
        </React.Fragment>
    );
};

export default InformationPage;
